import React from 'react'
import userlogo from '../assets/images/profile.png'
import { MdDashboard , MdPayment, MdNotifications } from "react-icons/md";
import { BiChevronRight, BiClinic } from "react-icons/bi";
import { HiUsers } from "react-icons/hi";
import { FaUserMd, FaClinicMedical, FaUser, FaChevronCircleRight } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Link, useNavigate } from 'react-router-dom';

export default function Sidebar() {

    const navigate = useNavigate();
    const userType = localStorage.getItem('type')
    const msidebar = () => {
    return (
        <>
            {/* <div id="dashboard-sidebar"> */}
                <div className=" profile-header ">
                    <div className='text-center sidebar-logo-section '>
                        <img src={userlogo} alt="img" className='img-fluid user-img' />
                        <h6>{localStorage.getItem('vplant_name')} </h6>
                        <h6 className='text-center mt-2' style={{ textTransform: 'capitalize' }}>( {localStorage.getItem('businessAreaName')} )</h6>
                    </div>
                </div>
                <div className="offcanvas-body profile-sidebar-body">
                    <PerfectScrollbar>
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            <div className="accordion-item new-accordion">
                                <Link to="../dashboard">  <button className=" collapsed acc-btn " type="button" >
                                    <MdDashboard className='mb-1 me-2' size={20} /> Dashboard
                                </button></Link>
                            </div>
                            {userType == 'admin' ? <div className="accordion-item new-accordion">
                                <button className=" collapsed acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" >
                                    <FaChevronRight  className='mb-1 me-2' size={16} /> Master
                                </button>
                                <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                    <div className="accordion-body">
                                        <ul className='acc-list' >
                                            <Link to='../branch'>  <li ><BiChevronRight className='mb-1 me-0' size={20} />  Branch</li></Link>
                                        </ul>
                                    </div>
                                </div>
                            </div> : ''}
                            {userType == 'admin' ? <div className="accordion-item new-accordion">
                                <button className=" collapsed acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" >
                                    <FaUser className='mb-1 me-2' size={20} /> Customer
                                </button>
                                <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                    <div className="accordion-body">
                                        <ul className='acc-list' >
                                            <Link to='../add-customer'><li ><BiChevronRight className='mb-1 me-0' size={20} />  Add Customer</li></Link>
                                            <Link to='../customer-list'><li ><BiChevronRight className='mb-1 me-0' size={20} />  Customer List </li></Link>
                                        </ul>
                                    </div>
                                </div>
                            </div> : ''}
                            <div className="accordion-item new-accordion">
                                {/* <button className=" collapsed acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree" >
                                    <FaChevronRight  className='mb-1 me-2' size={16} /> Order Managment
                                </button> */}
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('../add-order')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    New Order
                                </button>
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/sales-order-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    My Order List
                                </button>
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/ledger-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    My Ledger
                                </button>
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/invoice-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    Invoice List
                                </button>
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/product-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    Product List
                                </button>
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/age-analysis')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    Age Analysis
                                </button>
                              <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/sales-return-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                    Sales Return List
                                </button>
                                 {/*  <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/discount-voucher-list')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                 Voucher List
                                </button> 
                                <button
                                    className="collapsed acc-btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree"
                                    onClick={() => navigate('/debit-credit-note')}
                                >
                                    <FaChevronRight  className='mb-1 me-2' size={16} />
                                 Debit Credit Note
                                </button>*/}
                            </div>
                        </div>
                    </PerfectScrollbar>
                </div>
            {/* </div> */}
        </>
    )}

    let mobileScreen = window.screen.width <= 992;
    return (

        <>
            <div className="container-fluid">
                <div className="row">
                    {mobileScreen ? (<div className="offcanvas offcanvas-start dashoard-sidebar2 " data-bs-scroll="true" tabindex="-1" id="sideBar" aria-labelledby="offcanvasWithBothOptionsLabel" >{msidebar()}</div>)
                        :
                        (<div id="dashboard-sidebar">{msidebar()} </div >)}
                </div>
            </div>
        </>
    )
}
